module.exports = __webpack_public_path__ + "img/375.6e139949.jpg";